var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.allFiltersLength
    ? _c(
        "div",
        {
          staticClass: "search-header",
          staticStyle: { "text-align": "center" },
        },
        [
          _vm.showResultsButton
            ? _c(
                "div",
                {
                  staticClass: "search-show-button",
                  on: { click: _vm.searchHandle },
                },
                [_vm._v("Показать результаты")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "search-erase-button",
                on: { click: _vm.resetHandle },
              },
              [
                _c("i", { staticClass: "lnr lnr-cross" }),
                _vm._v(" Сбросить все настройки поиска\n        "),
              ]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }